// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupComponent } from '@med/app/shared/modules/popup/popup.component';
import { PopupTitleComponent } from '@med/app/shared/modules/popup/popup-title/popup-title.component';
import { PopupTextComponent } from '@med/app/shared/modules/popup/popup-text/popup-text.component';
import { PopupButtonsComponent } from '@med/app/shared/modules/popup/popup-buttons/popup-buttons.component';
import { ButtonModule } from '@med/app/shared/modules/button/button.module';
import { DividerModule } from '@med/app/shared/modules/divider/divider.module';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DividerModule,
  ],
  declarations: [
    PopupComponent,
    PopupTitleComponent,
    PopupTextComponent,
    PopupButtonsComponent,
  ],
  exports: [
    PopupComponent,
    PopupTitleComponent,
    PopupTextComponent,
    PopupButtonsComponent,
  ],
})
export class PopupModule {
}
